import { NgModule } from "@angular/core";

import { MedSignService } from "./med-sign.service";
import { MedSignComponent } from "./med-sign.component";

@NgModule({
  declarations: [
    MedSignComponent,
  ],
  exports: [
    MedSignComponent,
  ],
  providers: [
    MedSignService,
  ],
})
export class MedSignModule { }
